export const getFilter = (state) => state.clicksReports.filter;
export const getSort = (state) => state.clicksReports.allCountries.sort;
export const getStatisticsIndex = (state) => state.statisticsIndex;
